import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import { NumericPaginationContainer, SurveyPaginationControls, PaginationItem, PaginationArrow } from '../styles';
import { PaginationControlsProps } from '../types';

interface SectionPaginationProps {
	goToPage: (page: number, sectionIndex?: number) => void;
	hasNext: () => boolean;
	hasBack: () => boolean;
	handleNext: () => void;
	handleBack: () => void;
	currentPage: number;
	totalPages: number;
	isMobile: boolean;
}

export function PaginationControls({
	currentPage,
	handleBack,
	totalPages,
	handleNext,
	goToPage,
	isMobile,
	hasNext,
	hasBack
}: PaginationControlsProps) {
	return (
		<SurveyPaginationControls>
			<SectionPagination
				currentPage={currentPage}
				totalPages={totalPages}
				handleNext={handleNext}
				handleBack={handleBack}
				goToPage={goToPage}
				hasNext={hasNext}
				hasBack={hasBack}
				isMobile={isMobile}
			/>
		</SurveyPaginationControls>
	);
}

function SectionPagination({
	currentPage,
	handleNext,
	handleBack,
	totalPages,
	goToPage,
	hasNext,
	hasBack
}: SectionPaginationProps) {
	const showNavigationArrows = hasNext() || hasBack();

	const showPageNumbers = totalPages > 1;

	if (!showNavigationArrows && !showPageNumbers) {
		return null;
	}

	const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

	return (
		<NumericPaginationContainer>
			{showNavigationArrows && (
				<PaginationArrow onClick={hasBack() ? handleBack : undefined} disabled={!hasBack()}>
					<LeftOutlined />
				</PaginationArrow>
			)}

			{showPageNumbers &&
				pageNumbers.map((pageNumber) => (
					<PaginationItem
						isActive={currentPage === pageNumber}
						onClick={() => goToPage(pageNumber)}
						key={pageNumber}
					>
						{pageNumber}
					</PaginationItem>
				))}

			{showNavigationArrows && (
				<PaginationArrow onClick={hasNext() ? handleNext : undefined} disabled={!hasNext()}>
					<RightOutlined />
				</PaginationArrow>
			)}
		</NumericPaginationContainer>
	);
}
